import Sucessnotify from "../Components/Other_Components/Sucessnotify";
import React, { createContext, useContext, useState } from "react";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([]);

    const showToast = (type, message) => {
        const id = Date.now();
        setNotifications((prev) => [
            ...prev,
            { id, type, message, show: true },
        ]);

        setTimeout(() => {
            setNotifications((prev) =>
                prev.map((toast) =>
                    toast.id === id ? { ...toast, show: false } : toast
                )
            );
        }, 3000);

        setTimeout(() => {
            setNotifications((prev) => prev.filter((toast) => toast.id !== id));
        }, 4000);
    };

    return (
        <ToastContext.Provider value={{ showToast }}>
            <div className="fixed inset-0 z-50 pointer-events-none flex flex-col items-end space-y-5 p-4">
                {notifications.map((toast, index) => (
                    <Sucessnotify key={toast.id} type={toast.type} message={toast.message}/>
                ))}
            </div>
            {children}
        </ToastContext.Provider>
    );
};

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
}
